import { apiUrl } from '../config/apiConfig';

export const RequestPushMsg = (token, data) => {
    const url = apiUrl('send_notification');

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            "token": token,
            ...data
        })
    })
    .then((response) => {

    })
    .catch((error) => {
        console.log(error)
    });
}